import { render, staticRenderFns } from "./ButtonsSample.vue?vue&type=template&id=154d1c3b&scoped=true&"
import script from "./ButtonsSample.vue?vue&type=script&lang=js&"
export * from "./ButtonsSample.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsSample.vue?vue&type=style&index=0&id=154d1c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d1c3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtnToggle,VCardText,VCol,VIcon,VRow})
